import { render } from "./ClientTable.vue?vue&type=template&id=f510073a"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__